// extracted by mini-css-extract-plugin
export var brand = "_22-9";
export var compact = "_22-6";
export var extraSmall = "_22-7";
export var icon = "_22-0";
export var large = "_22-4";
export var light = "_22-1";
export var medium = "_22-5";
export var outline = "_22-b";
export var primaryDark = "_22-a";
export var primaryLight = "_22-8";
export var primaryModern = "_22-c";
export var success = "_22-2";
export var successSolid = "_22-3";